import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../../data/faq';
import { boxContents } from '../../data/packaging';

/** Objection-handling FAQ placed right before the closing call to action. */
export function HomeFaq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section aria-labelledby="home-faq-title" className="border-t mf-hairline bg-deep" data-id="element-248" data-mp="15qrc999i5dr2">
      <div className="mx-auto grid max-w-site gap-6 px-5 py-8 md:px-8 md:py-10 lg:grid-cols-[1fr_1.6fr] lg:gap-14" data-id="element-249" data-mp="1aq411zjxouwa">
        <div data-id="element-250" data-mp="1fhca2uhcqe8x">
          <h2 id="home-faq-title" className="font-display text-5xl font-semibold uppercase leading-[0.92] md:text-6xl" data-id="element-251" data-mp="1fh2kv944sb4a">
            Questions, <span className="text-ice" data-id="element-252" data-mp="i16gtqw5wo0w">answered.</span>
          </h2>
          <p className="mt-5 max-w-sm text-lg text-titanium" data-id="element-253" data-mp="mzhqo1mgiyj4">Everything homeowners ask before lighting their pool.</p>

          <div className="mf-hud mt-10 border border-marine/30 bg-[#06121F] p-6" data-id="element-254" data-mp="20jjdmegvb6qg">
            <h3 className="font-display text-xl font-semibold uppercase tracking-[0.08em] text-white" data-id="element-255" data-mp="1vm14amyxuphx">In every box</h3>
            <ul className="mt-4 space-y-3" data-id="element-256" data-mp="1qsos5cbg4b62">
              {boxContents.map(item => <li key={item} className="flex gap-3 text-[15px] text-titanium" data-id="element-257" data-mp="1luevsydzj4iv">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-marine" aria-hidden data-id="element-258" data-mp="1htuvxn211mt1" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-4 text-xs text-titanium/60" data-id="element-259" data-mp="17vf39fncq5hf">Per M1 PRO light. Systems include one light and one base per unit.</p>
          </div>

          <Link to="/faq" className="mt-8 inline-flex font-display text-base font-semibold uppercase tracking-[0.12em] text-white underline decoration-white/20 underline-offset-4 hover:text-ice hover:decoration-ice" data-id="element-260" data-mp="12xm0yxp65vmf">
            All FAQs &amp; support
          </Link>
        </div>

        <ul className="border-t mf-hairline" data-id="element-261" data-mp="vjuworbhoz3i">
          {faqs.slice(0, 8).map((f, i) => {
          const isOpen = open === i;
          const panelId = `home-faq-${i}`;
          return <li key={f.q} className="border-b mf-hairline" data-id="element-262" data-mp="lot93zwv4531" data-mpi={i}>
                <h3 data-id="element-263" data-mp="qlbbwu8mttcq">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice" data-id="element-264" data-mp="qmunw8n99i8p">
                    <span className="font-display text-xl font-semibold uppercase tracking-[0.03em] text-white md:text-2xl" data-id="element-265" data-mp="19engw32br3gf">{f.q}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-marine transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} aria-hidden data-id="element-266" data-mp="3u3bajisasmdo" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-267" data-mp="3hma82s7euviu">
                  {isOpen && <motion.div id={panelId} key="panel" initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-268" data-mp="bav44zp8ebx">
                      <p className="max-w-2xl pb-6 text-titanium" data-id="element-269" data-mp="38quiwohlp4jl">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}